import React, { useEffect } from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// This component handles language routing
// It changes the language based on URL param and renders the child component
const LanguageRoute = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const supportedLanguages = ['en', 'fr', 'es'];

  useEffect(() => {
    // If the language from URL is supported, change to it
    if (lang && supportedLanguages.includes(lang)) {
      i18n.changeLanguage(lang);
      localStorage.setItem("language", lang);
    }
  }, [lang, i18n]);

  // If language is not supported, redirect to English version
  if (lang && !supportedLanguages.includes(lang)) {
    // Preserve the rest of the path when redirecting
    const currentPath = location.pathname;
    const pathWithoutLang = currentPath.substring(currentPath.indexOf('/', 1) || currentPath.length);
    return <Navigate to={`/en${pathWithoutLang}`} replace />;
  }

  return children;
};

export default LanguageRoute;
